import { Archive02Icon } from '@hugeicons/react'

import { DigitalProductStoreBottomSheetRewardRequest } from '@/features/store/BottomSheet/RewardRequests/RewardRequest'

// Aba "Histórico": resgates retirados, expirados e reembolsados. Somente
// leitura — sem checkbox e sem ação de retirada.
export const DigitalProductStoreWithdrawBottomSheetHistory = ({
  rewardRequests,
  refetchRewardRequests
}) => {
  if (rewardRequests.length === 0)
    return (
      <div className="mb-10 flex flex-col items-center justify-center rounded-lg bg-gray-200 px-10 py-10 lg:px-20">
        <Archive02Icon
          width={56}
          height={56}
          variant="duotone"
          className="mb-6 text-gray-500"
        />
        <div className="text-center">
          <h1 className="mb-5 font-bold">Nada por aqui ainda</h1>
          <div className="mb-5 border-t border-dashed border-brand opacity-25" />
          <div className="text-sm text-gray-900">
            Suas reservas retiradas, expiradas ou reembolsadas aparecerão aqui
          </div>
        </div>
      </div>
    )

  return (
    <div className="flex flex-col gap-8">
      {rewardRequests.map((rewardRequest) => (
        <DigitalProductStoreBottomSheetRewardRequest
          key={rewardRequest.id}
          {...rewardRequest}
          onExpires={refetchRewardRequests}
          onWithdraw={refetchRewardRequests}
        />
      ))}
    </div>
  )
}
